import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MediaManager } from '@dev/ee-modules';
import { FileInfo } from '@dev/ee-api/ee-api-models';
import { Grid } from '@material-ui/core';
import { Dialog as MaterialDialog } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { ApplicationState } from '@/store';
import { HideDialog, ShowDialog } from '@/store/dialog/actions';
import { getUploadStore, UploadFilesMedia as UploadFiles } from '@/store/upload/actions';
import { getAccountStore } from '@/store/account/actions';
import { DeleteFile, DeleteFilesList, getUserFilesStore, LoadUserFiles } from '@/store/userfiles/actions';
import {
    getMediaManagerStore,
    HideMediaManager,
    HideMediaManagerUploader,
    ShowFileUpload,
    ShowMediaManagerUploader,
} from '@/store/mediaManager/actions';
import { ShowToast } from '@/store/toast/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { ModifyPaidNewsletterMetaData } from '@/store/paidNewsletterCreator/actions';
import { FileType } from '@/store/mediaManager/types';
import { ShowToastParams } from '@/store/toast/types';
import { CloseIconContainer, Overlay } from './styledComponents';

export const SocialShareMediaManager = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const account = useSelector(getAccountStore);
    const browser = useSelector((state: ApplicationState) => state.browser);
    const upload = useSelector(getUploadStore);
    const userFiles = useSelector(getUserFilesStore);
    const mediaManager = useSelector(getMediaManagerStore);

    const uploadFiles = (file: File) => dispatch(UploadFiles(file));
    const loadUserFiles = () => dispatch(LoadUserFiles());
    const deleteFile = (name: string, imageDelete: boolean) => dispatch(DeleteFile(name, imageDelete));
    const deleteFilesList = (filesList: string[], imagesDelete: boolean) =>
        dispatch(DeleteFilesList(filesList, imagesDelete));
    const showDialog = (params: ShowDialogParams) => dispatch(ShowDialog(params));
    const hideDialog = () => dispatch(HideDialog());
    const hideMediaManager = () => dispatch(HideMediaManager());
    const showMediaManagerUploader = () => dispatch(ShowMediaManagerUploader());
    const hideMediaManagerUploader = () => dispatch(HideMediaManagerUploader());
    const showFileUpload = (file: FileType) => dispatch(ShowFileUpload(file));
    const showToast = (params: ShowToastParams) => dispatch(ShowToast(params));

    const onFileSelected = (file: FileInfo) => {
        const fileUrl = `${APIPATH}/userfile/${account?.GeneralInfo?.PublicAccountID}/${file.FileName}`;
        dispatch(ModifyPaidNewsletterMetaData({ data: { socialPreview: { imageUrl: fileUrl }} }));
        dispatch(HideMediaManager());
    };

    const onMediaManagerClose = () => {
        dispatch(hideMediaManager());
    }

    return (
        <MaterialDialog open={mediaManager.isOpened} fullScreen={true} scroll={'body'} onClose={onMediaManagerClose}>
            <CloseIconContainer>
                <CloseIcon fontSize='large' onClick={onMediaManagerClose} />
            </CloseIconContainer>
            <Overlay>
            <Grid container justifyContent="center">
                <Grid item xs={12} sm={12}>
                    <MediaManager
                        onFileSelect={onFileSelected}
                        account={account}
                        browser={browser}
                        upload={upload}
                        userFiles={userFiles}
                        mediaManager={mediaManager}
                        APIPATH={APIPATH}
                        UploadFiles={uploadFiles}
                        LoadUserFiles={loadUserFiles}
                        DeleteFile={deleteFile}
                        DeleteFilesList={deleteFilesList}
                        ShowDialog={showDialog}
                        HideDialog={hideDialog}
                        HideMediaManager={hideMediaManager}
                        ShowMediaManagerUploader={showMediaManagerUploader}
                        HideMediaManagerUploader={hideMediaManagerUploader}
                        ShowFileUpload={showFileUpload}
                        ShowToast={showToast}
                        t={t}
                        imageTabOnly
                    />
                </Grid>
            </Grid>
        </Overlay>
        </MaterialDialog>
        
    );
};
